<template>
  <TeaserAccountTile>
    <template #component>
      <RequestUnlockCode :radioStyleOption="StyleOption.SECONDARY"></RequestUnlockCode>
    </template>

    <template #image>
      <TeaserPassword></TeaserPassword>
    </template>
  </TeaserAccountTile>
</template>

<script setup lang="ts">
import { StyleOption } from 'de-zurich-ui-library'
import TeaserPassword from '@/componentsTenant/rahmen/images/TeaserPassword.vue'
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'
import RequestUnlockCode from '@/components/account-management/requestunlockcode/RequestUnlockCode.vue'
</script>

<style scoped>
/* Your styles go here if needed */
</style>
